
let isLCC = (process.env.REACT_APP_PREFIX.includes("lcc"));

export function mapStatus(status) {
    if (isLCC) {
        return {
            "awaiting payment": "working",
            "waiting for shipment": "invoiced",
            "pending shipment": "invoiced",
            "shipped": "completed",
            "restored": "completed",
            "waiting for response": "working"
        }[status] ?? status;
    }
    return status;
}

export function reverseMapStatus(status) {
    if (isLCC) {
        return {
            "working": "awaiting payment",
            "invoiced": "waiting for shipment",
            "completed": "shipped"
        }[status] ?? status;
    }
    return status;
}

export function allStatuses() {
    if (isLCC) {
        return [
            "draft", "working", "rush", "invoiced", "completed"
        ];
    }
    return ["draft", "awaiting payment", "waiting for shipment", "pending shipment", "rush", "shipped", "restored", "closed", "waiting for response"];
}

export const PRIORITIES = [
    { value: 1, label: "1", color: "#FF0000" },
    { value: 2, label: "2", color: "#FF4500" },
    { value: 3, label: "3", color: "#b37400" },
    { value: 4, label: "4", color: "#939300" },
    { value: 5, label: "5", color: "#008000" },
    { value: 6, label: "6", color: "#00CED1" },
    { value: 7, label: "7", color: "#1E90FF" },
    { value: 8, label: "8", color: "#0000FF" },
    { value: 9, label: "9", color: "#8A2BE2" },
    { value: 10, label: "10", color: "#A9A9A9" },
    { value: 100, label: "default", color: "#cccccc" }
];

export function mapPriority(value) {
    return PRIORITIES.find((p) => p.value === value)?.label ?? 'normal';
}
